export const OFFLINE_QUEUE_KEY = 'offline-shopping-list-queue';
export const USER_HAS_LOGGED_IN_KEY = 'user-has-logged-in';
export const USER_EMAIL_KEY = 'user-email';
export const SKIP_PWA_INSTALL_PROMPT_KEY = 'skipPwaInstallPrompt';
export const DEFAULT_ITEM_IS_INGREDIENT_KEY = 'defaults-is-ingredient';
export const LANGUAGE_KEY = 'language';
export const VERSION_KEY = 'version';
export const ACTIVE_TAB_KEY = 'active-tab';
export const SHOPPING_LIST_SUGGESTIONS_KEY = 'shopping-list-suggestions';